"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositType = exports.InternalLoanType = exports.LoanType = void 0;
var LoanType;
(function (LoanType) {
    LoanType["SMALL_LOAN"] = "SMALL_LOAN";
    LoanType["REFINANCING_LOAN"] = "REFINANCING_LOAN";
    LoanType["HIRE_PURCHASE"] = "HIRE_PURCHASE";
    LoanType["PROJECT_LOAN"] = "PROJECT_LOAN";
    LoanType["HOUSING"] = "HOUSING";
    LoanType["HOUSING_LOAN"] = "HOUSING_LOAN";
    LoanType["CAR_LOAN"] = "CAR_LOAN";
    LoanType["RENOVATION_LOAN"] = "RENOVATION_LOAN";
    LoanType["MEDICAL_LOAN"] = "MEDICAL_LOAN";
    LoanType["BUSINESS_LOAN"] = "BUSINESS_LOAN";
    LoanType["REAL_ESTATE"] = "REAL_ESTATE";
    LoanType["CREDIT_LINE"] = "CREDIT_LINE";
    LoanType["OPERATING_LOAN"] = "OPERATING_LOAN";
    LoanType["PERSONAL_LOAN"] = "PERSONAL_LOAN";
    LoanType["RESTRUCTURING"] = "RESTRUCTURING";
    LoanType["PARTNER_LOAN"] = "PARTNER_LOAN";
    LoanType["REGULAR_HIRE_PURCHASE"] = "REGULAR_HIRE_PURCHASE";
    LoanType["COMPENSATED_HIRE_PURCHASE"] = "COMPENSATED_HIRE_PURCHASE";
    LoanType["CAR_LOAN_BUSINESS"] = "CAR_LOAN_BUSINESS";
    LoanType["CAR_LEASING_BUSINESS"] = "CAR_LEASING_BUSINESS";
    LoanType["CAR_HIRE_PURCHASE"] = "CAR_HIRE_PURCHASE";
    LoanType["CAR_HIRE_PURCHASE_COLLATERAL"] = "CAR_HIRE_PURCHASE_COLLATERAL";
    LoanType["OPERATING_LEASE"] = "OPERATING_LEASE";
    LoanType["FINANCE_LEASE"] = "FINANCE_LEASE";
    LoanType["TRAVEL_LOAN"] = "TRAVEL_LOAN";
    LoanType["MOBILE_CREDIT_CARD"] = "MOBILE_CREDIT_CARD";
    LoanType["DEVELOPMENT_LOAN"] = "DEVELOPMENT_LOAN";
    LoanType["PRIVATE_CREDIT"] = "PRIVATE_CREDIT";
    LoanType["SMALL_LOAN_BUSINESS"] = "SMALL_LOAN_BUSINESS";
    LoanType["INVESTMENT_LOAN"] = "INVESTMENT_LOAN";
    LoanType["MORTGAGE_LOAN"] = "MORTGAGE_LOAN";
})(LoanType || (exports.LoanType = LoanType = {}));
var InternalLoanType;
(function (InternalLoanType) {
    InternalLoanType["LOAN"] = "LOAN";
    InternalLoanType["REVOLVING"] = "REVOLVING";
    InternalLoanType["HOUSING"] = "HOUSING";
    InternalLoanType["CREDIT_CARD"] = "CREDIT_CARD";
    InternalLoanType["LEASING"] = "LEASING";
    InternalLoanType["REAL_ESTATE"] = "REAL_ESTATE";
})(InternalLoanType || (exports.InternalLoanType = InternalLoanType = {}));
var DepositType;
(function (DepositType) {
    DepositType["TERM_DEPOSIT"] = "TERM_DEPOSIT";
    DepositType["SAVINGS_DEPOSIT"] = "SAVINGS_DEPOSIT";
})(DepositType || (exports.DepositType = DepositType = {}));
